import { useState, useEffect } from 'react';
import { Outlet } from 'react-router-dom';
import Menu from './Menu';
import Logo from '../images/stlog-logo.svg'; 
import Footer_text from '../images/footer_text.png'; 

const Layout = (props) => {

    const [email, setEmail] = useState("");
    const [menuClass, setMenuClass] = useState("");


    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'));
        setEmail(user.email)
        console.log(window.innerWidth)
        if (window.innerWidth < 600){ // Detect is on mobile
            setMenuClass("hidden");
        }
    }, [])

    const menuClick = () => {
        console.log("clicked")
        if (menuClass === ""){
            setMenuClass("hidden")
            console.log("Set Menu Class: Hidden")
        }
        else{
            setMenuClass("")
            console.log("Set Menu Class: Blank")
        }
    }

    return (
        <div className="App" align="left">

            <div className='title_header'>
                <table width="100%">
                    <tbody>
                        <tr>
                            <td align="left" width={"50px"}><i className="bi-list" style={{fontSize: "2rem", color: "white"}} onClick={menuClick}></i></td>
                            <td align="left" ><img style={{width:"180px"}} src={Logo} alt='stlog-logo'></img></td>
                            <td align="right">
                                <div align="right" style={{ paddingRight: "20px" }}>
                                    <div className='title_login'>Logged in as</div>
                                    <div className='title_email'>{email}</div>
                                </div>

                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>

            <div align='left'>
                <div>
                    <table width="100%" cellPadding="0" cellSpacing="0">
                        <tbody>
                            <tr>
                                <td width="180px" valign="top" className={`menu ${menuClass}`}>
                                    <div className={`menu_side_bar`} align='left'>
                                        <Menu id={props.id} />
                                    </div>
                                </td>
                                <td valign="top">
                                    <div className="main-content"><Outlet /></div>
                                    <div align="left" className='footer_text'><img className='footer_img ' src={Footer_text} alt='Footer_text'></img></div>
                                </td>
                            </tr>
                        </tbody>
                    </table>
                </div>
                
            </div>
        </div>
    )
}

export default Layout